import { render, staticRenderFns } from "./SidebarEmail.vue?vue&type=template&id=05fc3e6b&scoped=true&"
import script from "./SidebarEmail.vue?vue&type=script&lang=js&"
export * from "./SidebarEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc3e6b",
  null
  
)

export default component.exports